const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-smart-mobility-utils/shared/ui/Widget/RowToWidget/RowToWidget");